module.exports = __webpack_public_path__ + "visa-icon.png?f3da14689a01546b2114e07e8c19d0fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visa-icon.png
// module id = 1037
// module chunks = 0